/* eslint-disable @typescript-eslint/no-magic-numbers */
export interface IUserAddressesServiceProvider {
  searchAddresses(): Promise<IUserAddressesList>;
  retrieveViewAddress(req: IUserAddressRequest): Promise<IUserViewAddress>;
  createAddress(req: IUserAddressCreateFrontend): Promise<IUserAddressesList>;
  updateAddress(req: IUserAddressUpdateFrontend): Promise<IUserAddressesList>;
  retrieveEditAddress(req: IUserAddressRequest): Promise<IUserAddressEditForm>;
  deleteAddress(req: IUserAddressRequest): Promise<IUserAddressesList>;
  restoreAddress(req: IUserAddressRequest): Promise<IUserAddressesList>;
}

export interface IUserAddressesList {
  data?: IUserAddressesListItem[] | null;
}

export interface IUserAddressesListItem {
  id?: string | null;
  city?: string | null;
  value?: string | null;
  label?: string | null;
  isDeleted?: boolean | null;
  isDeletedString?: string | null;
  addressTypeLabel?: string | null;
  link?: string | null;
  serviceAvailable?: null | boolean;
  needsToComplete?: null | boolean;
}

export enum ADDRESS_TYPE {
  UNDEFINED_ADDRESS_TYPE = 0,
  DEFAULT = 1,
  BIRTH_ADDRESS = 2,
  REG_ADDRESS = 3,
  RESIDENCE_ADDRESS = 4,
  PICKUP_POINT = 5,
}

export interface IUserAddressRequest {
  addressId?: string | null;
}

export interface IUserViewAddress {
  id?: string | null;
  addressLink?: IAddressLink | null;
  intercom?: string | null;
  metro?: IMetroStation[] | null;
  isDeleted?: boolean | null;
  isDeletedStatus?: string | null;
  comment?: string | null;
}

export interface IAddressLink {
  addressLink?: string | null;
  addressString?: string | null;
}

export interface IMetroStation {
  color?: string | null;
  name?: string | null;
  distance?: string | null;
}

export interface IUserAddressCreateFrontend {
  newAddress?: IUserAddressForm | null;
}

export interface IUserAddressForm {
  type?: ADDRESS_TYPE | null;
  value?: IAddress | null;
}

export interface IAddress {
  id?: string | null;
  label?: string | null;
  value?: string | null;
  unrestrictedValue?: string | null;
  object?: string | null;
  detail?: IAddressDetail | null;
  coordinates?: ICoordinates | null;
  metro?: IMetro[] | null;
  type?: ADDRESS_TYPE | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  isDeleted?: boolean | null;
  deletedAt?: string | null;
}

export interface IAddressDetail {
  region?: string | null;
  city?: string | null;
  area?: string | null;
  street?: string | null;
  block?: string | null;
  house?: string | null;
  flat?: string | null;
  floor?: string | null;
  comment?: string | null;
  intercom?: string | null;
  entrance?: string | null;
  settlement?: string | null;
}

export interface ICoordinates {
  lat?: number | null;
  lng?: number | null;
}

export interface IMetro {
  distance?: number | null;
  line?: string | null;
  name?: string | null;
}

export interface IUserAddressUpdateFrontend {
  address?: IUserAddressForm | null;
}

export interface IUserAddressEditForm {
  type?: ADDRESS_TYPE | null;
  value?: IAddress | null;
}
